import React, { useEffect } from 'react';
import styles from '../css/AcordeonFiltros.module.scss'

export const AcordeonFiltros = ({ items }) => {
    return (
        <div class={"accordion " + styles.acordeon} id="accordionFiltros">

            {items.map(function (elem, i) {
                return (
                    <div class="accordion-item">
                        <h2 class="accordion-header border-bottom" id={"heading" + i}>
                            <button class={"accordion-button fw-bold "+ (elem.descripcion.length != 0  ? '' : 'collapsed')} type="button" data-bs-toggle="collapse" data-bs-target={"#collapse" + i}
                                aria-expanded={elem.descripcion.length != 0 ?true:false} aria-controls={"collapse" + i} disabled={elem.descripcion.length === 0}>
                                {elem.titulo}
                            </button>
                        </h2>
                        <div id={"collapse" + i} class={"accordion-collapse collapse " + (elem.descripcion.length != 0 ? 'show': '')} aria-labelledby={"heading" + i} >
                            <div class="accordion-body">
                                {elem.descripcion}
                            </div>
                        </div>
                    </div>
                )
            })}
        </div>
    )

}
